import keyMirror from "keymirror";

export const AINewsConstants = {
  ActionTypes: keyMirror({
    SET_MESSAGE: null,
    GET_COMPETITIVE_EDGE_REQUEST: null,
    GET_COMPETITIVE_EDGE_SUCCESS: null,
    GET_COMPETITIVE_EDGE_FAILURE: null,
    SET_AI_TEXT_REACTION: null,
    SET_FUTURE_EVENT_REACTION: null,
    GET_ZIGZAG_TREND_DATA_REQUEST: null,
    GET_ZIGZAG_TREND_DATA_SUCCESS: null,
    GET_ZIGZAG_TREND_DATA_FAILURE: null,
    SAVE_AI_REACTIONS: null,
    CLEAR_REACTIONS: null,
    GET_FINANCIAL_BLOCK_METRICS_DATA_REQUEST: null,
    GET_FINANCIAL_BLOCK_METRICS_DATA_SUCCESS: null,
    GET_FINANCIAL_BLOCK_METRICS_DATA_FAILURE: null,
    SET_POPUP_CONFIG: null,
    CLEAR_POPUP_CONFIG: null,
    GET_TRACK_PRICE_AI_NEWS_REQUEST: null,
    GET_TRACK_PRICE_AI_NEWS_SUCCESS: null,
    GET_TRACK_PRICE_AI_NEWS_FAILURE: null,
    CLOSE_POPUP: null,
    UPDATE_FUTURE_EVENTS_ALLOWED: null,
    UPDATE_FUTURE_EVENTS: null,
    SET_TRIGGER_CLOSE: null,
    SET_AI_FUTURE_EVENTS_GUTTER_QTR: null,
  }),
};

export const AINewsType = {
  COMPETITIVE_NEWS: 1,
  TREND_NEWS: 2,
  FINANCIAL_BLOCK_METRICS: 3,
  TRACK_PRICE_AI_NEWS: 4,
  FUTURE_EVENTS: 5,
};

export const AllowedFinancialMetricIds = {
  "EPS % CHANGE": { name: "EPS", headerId: 3 },
  "SALES % CHANGE": { name: "Sales", headerId: 5 },
  "GROSS MARGIN": { name: "Gross Margin", headerId: 13 },
};

export const TREND = {
  UP_TREND: 1,
  DOWN_TREND: 2,
};

export const TREND_TYPE = {
    UP_TREND: "UP",
    DOWN_TREND: "DOWN",
}

export const REACTIONS = {
  LIKE: 1,
  DISLIKE: 2,
  UNSURE: 3,
};

export const AI_FUTURE_EVENT_TYPES = {
  CRITICAL: "1",
  COMPANY_NEWS: "2",
  PRODUCT_NEWS: "3",
  INDUSTRY: "4",
  GOVERNMENT_REGULATORY: "5",
  EARNINGS: "6",
};

export const AI_FUTURE_EVENT_LABELS = {
  "EARNINGS Q4": "ER",
  "EARNINGS RELEASE": "ER",
  "EARNINGS REPORT": "ER",
  "EARNINGS": "ER",
  "EARNINGS CALL": "ER",
  "H1 RESULTS": "ER",
  "EARNINGS Q2": "ER",
  "FOMC": "FOMC",
  "FEDERAL OPEN MARKET COMMITTEE": "FOMC",
  "INDEX REMOVAL": "-index",
  "INDEX ADDITION": "+index",
  "CLASS ACTION": "legal",
  "CLASS LAWSUIT": "legal",
  "LEAD PLAINTIFF": "legal",
  "LEGAL DEADLINE": "legal",
  "LEAD PLAINTIFF DEADLINE": "legal",
  "CASE DISMISSAL": "legal",
  "SCHEME SANCTION": "legal",
  "LOCK-UP EXPIRATION": "LPE",
  "ARM TRIAL": "legal",
  "BC COURT APPROVAL": "legal",
  "EARNINGS RELEASE AND CALL": "ER",
  "EARNINGS RELEASE AND CONFERENCE CALL": "ER",
  "EARNINGS RELEASE AND WEBCAST": "ER",
  "EARNINGS RESULTS": "ER",
  "EARNINGS UPDATE": "ER",
  "FTC TRIAL": "legal",
  "GRENSHOE EXPIRY": "LPE",
  "HYTERA SENTENCING": "legal",
  "INDEX CHANGE": "-index",
  "INDEX PUBLICATION": "",
  "INVESTOR DAY": "",
  "LOCKUP EXPIRY": "LPE",
  "LOCK-UP EXPIRY": "LPE",
  "NJ SETTLEMENT": "legal",
  "PFAS SETTLEMENT": "legal",
  "PRELIMINARY RESULTS": "ER",
  "PSC HEARING": "legal",
  "Q3 2025 EARNINGS RELEASE AND CONFERENCE CALL": "ER",
  "Q3 2025 EARNINGS RELEASE AND INVESTOR CALL": "ER",
  "Q3 EARNINGS": "ER",
  "Q3 EARNINGS AND CONFERENCE CALL": "ER",
  "Q3 EARNINGS RELEASE AND CONFERENCE CALL": "ER",
  "Q3 RESULTS": "ER",
  "Q3 RESULTS AND EARNINGS CALL": "ER",
  "Q4 EARNINGS": "ER",
  "Q4 END": "ER",
  "Q4 RESULTS": "ER",
  "RATE HEARING": "legal",
  "REGULATORY HEARING": "legal",
  "SETTLEMENT HEARING": "legal",
  "TRANSITION RESULTS": "ER",
  "VOLUME LIMIT EXPIRY": "legal",
  "Financial Results": "ER",
  "Lockup Expiry": "LPE",
  "Lawsuit": "legal",
  "Securities Class Action": "legal",
  "Q1": "ER",
  "Q2": "ER",
  "Q3": "ER",
  "Q4": "ER",
  "Fourth Quarter":	"ER",
  "Quarterly Results":	"ER",
  "First Quarter":	"ER",
  "Second Quarter":	"ER",
  "Third Quarter":	"ER",
  "Antitrust Trial": "legal",
  "Financial reports":	"ER",
  "Annual Results":	"ER",
  "Interim Report":	"ER",
  "Annual Report":	"ER",
  "Results Announcement":	"ER"
};
